import React, { FC, useState } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { Form, FormDrawer } from '~/components';
import { usePermissions } from '~/hooks';
import { useBeneficiaryAccountsCreate } from '~/hooks/beneficiaryAccounts';
import { Beneficiary, BeneficiaryAccount } from '~/types';
import AccountFormItems from './AccountFormItems';

interface Props {
  beneficiary: Beneficiary;
}

const AddAccount: FC<Props> = (props) => {
  const { beneficiary } = props;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [form] = Form.useForm();

  const { mutate, isLoading } = useBeneficiaryAccountsCreate({ onMutate: handleClose });

  const createAccount = (account: BeneficiaryAccount) => {
    // const result = { ...beneficiary };
    const p = account.parameters;
    let newName = account.serviceName;
    if (p.accountNumber) {
      newName = `${newName} ${p.accountNumber.value}`;
    } else if (p.iban) {
      newName = `${newName} ${p.iban.value}`;
    }

    const result = {
      ...account,
      name: newName,
      solutionId: beneficiary.solutionId,
      profileId: beneficiary.profileId,
      beneficiaryId: beneficiary.id,
    };
    // result.nominatedAccounts = [values].concat(result.nominatedAccounts || []);
    mutate(result);
  };

  const onFinish = (account: BeneficiaryAccount) => {
    const { setAsPrimary } = account;
    if (setAsPrimary) {
      Modal.confirm({
        title: t('sureAddOrEdit'),
        content: t('addPrimaryAccount'),
        icon: <ExclamationCircleOutlined />,
        okText: dt('yes'),
        okType: 'danger',
        cancelText: dt('no'),
        onOk() {
          createAccount(account);
        },
      });
    } else createAccount(account);
  };

  const [t] = useTranslation('payouts');
  const dt = (key: string): string => t(`translation:${key}`);
  const hasAccessUpdate = usePermissions('business.beneficiary.update');
  if (!hasAccessUpdate) return null;
  return (
    <>
      <Button shape="round" onClick={handleOpen}>
        {t('addAccount')}
      </Button>
      <FormDrawer
        name={name}
        onFinish={onFinish}
        title={t('addAccount')}
        onClose={handleClose}
        visible={open}
        loading={isLoading}
      >
        <Form form={form} layout="vertical" name={name} initialValues={{ setAsPrimary: true }}>
          <AccountFormItems form={form} />
        </Form>
      </FormDrawer>
    </>
  );
};

const name = 'nominatedAccount';

export default AddAccount;
